module.exports = __webpack_public_path__ + "img/banner.859d61a6.png";